const breakpoints = {
  s: '600px',
  m: '900px',
  l: '1024px',
  xl: '1200px',
}

export const media = {
  down: (size: keyof typeof breakpoints) => `@media (max-width: ${breakpoints[size]})`,
  up: (size: keyof typeof breakpoints) => `@media (min-width: ${breakpoints[size]})`,
}
